<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 330 330" width="7" height="7" style="enable-background:new 0 0 330 330;"
        xml:space="preserve">
        <path id="XMLID_29_"
            d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M165,247.5 c-45.49,0-82.5-37.009-82.5-82.5s37.01-82.5,82.5-82.5s82.5,37.009,82.5,82.5S210.49,247.5,165,247.5z" />
    </svg>
</template>